import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import FaqSection from 'components/no-auth/common/sections/FaqSection';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import LoneButtonSection from 'components/no-auth/common/sections/LoneButtonSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import TrustpilotSection from 'components/no-auth/common/sections/TrustpilotSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const AmbassadorPage = (props) => {
    return (
        <>
            <PromoPageContainer bgColor="eggshell03" noIndent>
                {props.heroTitle && (
                    <HeroSection
                        title={props.heroTitle}
                        text={props.heroText}
                        heroNote={props.heroNote}
                        img={props.heroImg}
                        data={props.heroData}
                        btnVariant={'primary'}
                        isInvertedBtn
                        noIconBtn
                    />
                )}
                <ColoredSectionContainer>
                    {props.headline1Title && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}
                    {props.headline2Title && <HeadingSection title={props.headline2Title} text={props.headline2Text} />}
                    {props.tiles && <TilesSection data={props.tiles} lang={props.lang} country={props.country} loadingLazy grayText />}
                    {props.termsLink && <LoneButtonSection btn={props.termsLink} variant="tertiary" />}
                    {props.lang && props.termsLink && <TrustpilotSection lang={props.lang} />}
                </ColoredSectionContainer>

                {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} noTopPadding />}
            </PromoPageContainer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroNote: state.extra?.strapiApi?.hero_block?.hero_note,
        heroData: state.extra?.strapiApi?.hero_block,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroImg: state.extra?.strapiApi?.hero_block?.img,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,

        tiles: state.extra?.strapiApi?.tiles_section,

        termsLink: state.extra?.strapiApi?.terms_link,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(AmbassadorPage));
